import {HttpClient} from "../../service/httpClient/HttpClient";
import moment from "jalali-moment";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class OtherPaymentService {

    constructor(fundID, token, snackbar, loading) {
        this.fundID = fundID;
        this.token = token;
        this.snackbar = snackbar;
        this.loading = loading;

        this.httpClient = new HttpClient()
    }


    getOtherPaymentList(page, size = 10) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/other-payments`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page: page,
                    size: size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewPayment(fundID, paymentData, clearFields) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.post(
            `fund-presentation/funds/${this.fundID}/other-payments`,
            paymentData,
            this.httpClient.prepareUserAccessHeader(this.token)
        ).then(response => {
            clearFields()
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "پرداختی جدید با موفقیت افزوده شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در افزودن پرداختی جدید!", this.snackbar, this.loading)
        })
    }

    prepareOtherPaymentJson(
        title,
        startDate,
        endDate,
        unit,
        amountPerUnit,
        expirationDate,
        description,
        enabled
    ) {
        return {
            "title": title,
            "startDate": moment.from(startDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') + "T00:00",
            "endDate": moment.from(endDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') + "T23:59",
            "description": description,
            "unit": unit,
            "amountPerUnit": amountPerUnit,
            "hasExpiredTime": expirationDate,
            "enabled": enabled
        }
    }

    getOtherPaymentContent(paymentId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/other-payments/${paymentId}`,
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(resolve).catch(reject)
        })
    }

    updatePayment(fundID, paymentId, paymentData) {
        this.loading(setLoadingStateDispatch(true))
        this.httpClient.put(
            `fund-presentation/funds/${fundID}/other-payments/${paymentId}`,
            this.httpClient.prepareUserAccessHeader(this.token),
            paymentData
        ).then(response => {
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "بروزرسانی جزئیات پرداختی با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در بروزرسانی جزئیات پرداختی!", this.snackbar, this.loading)
        })
    }

    getBuyRequestsList(page, selectedItem, size = 10) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${this.fundID}/other-payments/${selectedItem}/reservations`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    getAccountsTransactions(fundID, userId, page, size = 15) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-presentation/funds/${fundID}/deposit-accounts/${userId}/movements`,
                this.httpClient.prepareUserAccessHeader(this.token),
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }
}

export const otherPaymentKinds = {
    BASED_ON_PRODUCT_SALES_WITHOUT_RESTRICTIONS: {
        id: "BASED_ON_PRODUCT_SALES_WITHOUT_RESTRICTIONS",
        title: "فروش بدون محدودیت تعداد"
    },
    BASED_ON_PRODUCT_SALES_WITH_RESTRICTIONS: {
        id: "BASED_ON_PRODUCT_SALES_WITH_RESTRICTIONS",
        title: "فروش با محدودیت تعداد"
    },
    BASED_ON_AMOUNT_OF_INTEREST: {
        id: "BASED_ON_AMOUNT_OF_INTEREST",
        title: "فروش با مبلغ دلخواه"
    },
}